<template>
  <div class="quality-course">
    <VipAd />
    <div class="course-main">
      <div class="course-main__menu">
        <MyMenu :typeName.sync="typeName" />
      </div>
      <div class="course-main__focus">
        <div class="main__focus--tool">
          <div class="course-count">共{{list.length && list[activeIdx].count}}门课程</div>
          <div class="course-sort">
            <div
              class="course-sort__item"
              v-for="(item, index) in sortObj"
              :class="{ 'course-sort__item--active': item.id === sort }"
              :key="index"
              @click="handlerChangeSort(item.id)"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <div
          class="course-list"
          v-for="(val, idx) in list"
          :key="idx"
          v-show="val.typeName === typeName && val.sort === sort"
        >
          <van-list
            v-model="val.loading"
            :finished="val.finished"
            finished-text=""
            @load="handlerLoad"
          >
            <CourseCard
              v-for="(item, index) in val.courseList"
              :data="item"
              :key="index"
            />
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref, reactive, watch, toRefs
} from '@vue/composition-api';
import VipAd from '@/components/vipAd/index.vue';
import { getQualityCourseList } from '@/api/list';
import { List } from 'vant';
import MyMenu from './components/MyMenu.vue';
import CourseCard from './components/CourseCard.vue';

export default {
  components: {
    VipAd,
    MyMenu,
    CourseCard,
    [List.name]: List,
  },
  setup() {
    const typeName = ref('全部课程');

    const { sort, sortObj, handlerChangeSort } = useSort();

    const course = reactive({
      /**
       * @description 数据结构如下：
       * [{typeName: 分类名, count: 总数, sort: 排序ID, courseList: '课程列表', loading, finished}]
       */
      list: [],
      /**
       * @description 当前展示分类的数据在list中的索引
       */
      activeIdx: -1
    });

    useGetCourses(sort.value, typeName.value, course, -1);

    /**
     * @description 滚动加载
     */
    const handlerLoad = () => {
      useGetCourses(sort.value, typeName.value, course, course.activeIdx);
    };

    watch([typeName, sort], (val) => {
      // 初始化
      if (!course.list.length) {
        useGetCourses(sort.value, typeName.value, course, -1);
        return;
      }

      // 查询当前分类和排序方式是否已有数据
      const idx = course.list.findIndex(
        item => item.typeName === val[0] && item.sort === val[1]
      );

      // 该类目已经加载完了所有数据
      if (idx !== -1 && course.list[idx].finished) {
        course.activeIdx = idx;
        return;
      }

      useGetCourses(sort.value, typeName.value, course, idx);
    });

    return {
      typeName,
      sort,
      sortObj,
      handlerChangeSort,
      ...toRefs(course),
      handlerLoad,
    };
  },
};

/**
 * @description 排序相关操作
 */
function useSort() {
  const sortObj = [
    { id: 0, text: '最新' },
    { id: 1, text: '最热' },
  ];

  const sort = ref(sortObj[0].id);

  const handlerChangeSort = (id) => {
    if (id !== sort.value) {
      sort.value = id;
    }
  };

  return {
    sort,
    sortObj,
    handlerChangeSort,
  };
}

/**
 * @description 请求课程数据，并放入对应位置
 * @param {number} sort 排序ID
 * @param {string} typeName 分类名
 * @param {object} course
 * @param {Boolean} course.loading
 * @param {Boolean} course.finished
 * @param {object[]} course.list
 * @param {number} course.activeIdx
 * @param {number} idx 索引：数据需要插入course.list的哪个位置，-1代表插入一个新项
 */
function useGetCourses(sort, typeName, course, idx) {
  const data = {
    sort,
    offset: 0,
    lesson_label: typeName,
    limit: 10,
  };

  if (idx !== -1) {
    data.offset = course.list[idx].courseList.length;
  }

  getQualityCourseList(data).then((res) => {
    if (!res.data) {
      if (idx !== -1) {
        course.list[idx].loading = false;
      }

      return;
    }

    // 只保存需要的数据
    let list = res.data.items;
    if (list.length) {
      list = list.map(item => ({
        id: item.id,
        courseName: item.name,
        teacherName: item.teacher_name,
        cover: item.cover_image,
        price: item.price,
        learningNum: item.camp_sale_count,
        status: item.camp_status,
        oldUrl: item.full_home_url,
      }));
    }

    // 将新数据作为一个新类目添加入course.list中
    if (idx === -1) {
      course.list.push({
        typeName: data.lesson_label,
        courseList: list,
        count: res.data.count,
        sort: data.sort,
        loading: false,
        finished: false
      });

      course.activeIdx = course.list.length - 1;
    }

    // 该类目已存在，将数据添加到course.list中的对应类目
    if (idx !== -1) {
      course.list[idx].courseList.push(...list);
      course.activeIdx = idx;
    }

    if (list.length < data.limit) {
      course.list[course.activeIdx].finished = true;
    }

    course.list[course.activeIdx].loading = false;
  });
}
</script>

<style lang="stylus" scoped>
.quality-course {
  position: relative;
  height: 100vh;
  background: #fff;

  .course-main {
    position: absolute;
    top: 49px;
    left: 0;
    display: flex;
    width: 100%;
    height: calc(100vh - 49px);
    background: #fff;

    .course-main__menu {
      overflow-y: auto;
      width: 80px;
      height: calc(100vh - 49px);
      background: #F6F7FA;
    }

    .course-main__focus {
      flex: 1 1 0%;
      // width calc(100% - 80px)
    }
  }
}

.main__focus--tool {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 40px;
  color: #999;

  .course-count {
    font-size: 14px;
  }

  .course-sort {
    display: flex;
    align-items: center;
    height: 24px;

    .course-sort__item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 24px;
      border-radius: 12px;
      font-size: 12px;
    }

    .course-sort__item--active {
      background: #EDF5FA;
      color: #FF9645;
    }
  }
}

.course-list {
  overflow-y: auto;
  padding: 0 16px;
  height: calc(100vh - 49px - 40px);
}
</style>
